import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tree-square-dot-vertical"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 8V3L21 3V8H16Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 21V16H21V21H16Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 14.5L3 9.5H8V14.5H3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 12H12.3333M12.3333 12L12.3333 18.5H16M12.3333 12V5.5L16 5.5M16 8V3L21 3V8H16ZM16 21V16H21V21H16ZM3 14.5L3 9.5H8V14.5H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TreeSquareDotVertical = Vue.extend<IconProps>({
  name: 'TreeSquareDotVerticalIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tree-square-dot-vertical',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TreeSquareDotVertical;
